module.exports = __webpack_public_path__ + "static/media/amara.9e50f825.jpg";